import { formatPremium } from './formatPremium';

export function PremiumBlock({ label, premium, className }: { label: string; premium?: string; className?: string }) {
    const formattedPremium = formatPremium(premium);
    return (
        <div className={`relative flex h-[56px] md:h-[56px] lg:h-[38px] w-fit flex-col items-start justify-center gap-0 md:gap-1 rounded-lg bg-white px-3 lg:flex-row lg:items-center lg:gap-2 ${className}`}>
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    padding: 1,
                    borderRadius: 8,
                    background: 'linear-gradient(143.77deg, #0277E0 0%, #1357B0 101.42%)',
                    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                    WebkitMaskComposite: 'xor',
                    maskComposite: 'exclude',
                    pointerEvents: 'none',
                }}
            />
            <span className="relative text-sm font-normal text-gray-500 whitespace-nowrap">{label}</span>
            <span className="relative text-base font-medium text-primary-500 leading-none whitespace-nowrap tabular-nums">
                {formattedPremium}
            </span>
        </div>
    );
}

